import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {

  title: string;
  description: string;
  accept: string;
  reject :string;
  hasOkBtn: boolean = true;

  constructor(public modalRef: BsModalRef) { }

  confirm() { } //external override
  onConfirm() {
    if (typeof this.confirm == "function") this.confirm();
    this.modalRef.hide()
  }

  decline() { } //external override
  onDecline() {
    if (typeof this.decline == "function") this.decline();
    this.modalRef.hide()
  }

}